const initialState = {
	errors: null,
	membersLoading: false,
	members: {},
};

export default initialState;
